import { UserReactionsList } from './ReactionsList';
import { UserSeenList } from './SeenList';
import { usePresenter } from './presenter';

export const UserList = ({ tabs }) => {
  const presenter = usePresenter({ tabs });

  return presenter.isUserSeenList ? (
    <UserSeenList list={tabs.currentTab.list} />
  ) : (
    <UserReactionsList list={tabs.currentTab.list} />
  );
};
